import React, { useEffect } from "react";

/**
 * Contenedor visual estándar para páginas legales (Aviso Legal, Privacidad, Cookies).
 * - Título grande, fecha de actualización, y prose consistente.
 * - Sin markdown parser: los children son JSX estructurado.
 */
export default function LegalLayout({ eyebrow, title, updatedAt, children, testId }) {
    useEffect(() => {
        if (typeof document !== "undefined" && title) {
            document.title = `${title} · ASATTA`;
        }
    }, [title]);

    return (
        <div data-testid={testId} className="bg-white">
            <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-24">
                <div className="text-xs uppercase tracking-widest text-[#082050]/70 mb-4">
                    {eyebrow}
                </div>
                <h1 className="text-4xl sm:text-5xl font-semibold text-[#082050] tracking-tight">
                    {title}
                </h1>
                {updatedAt && (
                    <p className="mt-3 text-sm text-[#718096]">
                        Última actualización: {updatedAt}
                    </p>
                )}
                <div className="mt-12 legal-content">
                    {children}
                </div>
            </section>
        </div>
    );
}
